import { Json } from '@homeleite/arch';

export class AuditData {
    constructor(
        public created: Date = null,
        public modifiedByApp: Date = null,
        public modifiedByIntegration: Date = null,
        public responseByIntegration: string = null,
        public createdByIntegration: Date = null,
        public createdByApp: Date = null
    ) {}

    toJson(): any {
        return Json.to.simple(this, {
            created: this.created?.toISOString() ?? null,
            modifiedByApp: this.modifiedByApp?.toISOString() ?? null,
            modifiedByIntegration: this.modifiedByIntegration?.toISOString() ?? null,
            createdByIntegration: this.createdByIntegration?.toISOString() ?? null,
            createdByApp: this.createdByApp?.toISOString() ?? null
        });
    }

    static fromJson(json: any): AuditData {
        if (!json) return null;

        return new AuditData(
            json.created ? new Date(json.created) : null,
            json.modifiedByApp ? new Date(json.modifiedByApp) : null,
            json.modifiedByIntegration ? new Date(json.modifiedByIntegration) : null,
            json.responseByIntegration ?? null,
            json.createdByIntegration ? new Date(json.createdByIntegration) : null,
            json.createdByApp ? new Date(json.createdByApp) : null
        );
    }
}
